import { BottomViewsHeaderProps } from './types';

export const BottomViewsHeader = ({ children }: BottomViewsHeaderProps) => {
  return (
    <div style={{ display: 'flex', padding: '1rem', gap: '1rem' }}>
      {children}
    </div>
  );
};
